import { inject, Injectable } from "@angular/core";
import { WebsocketClientWrapper } from "../../market/websocket-client-factory";
import { BybitOrderHandler } from "./exchange/bybit-order.handler";
import { BinanceOrderHandler } from "./exchange/binance-order.handler";
import { OkxOrderHandler } from "./exchange/okx-order.handler";

@Injectable({
  providedIn: 'root'
})
export class OrderHandler {

  private bybitHandler = inject(BybitOrderHandler)
  private binanceHandler = inject(BinanceOrderHandler)
  private okxHandler = inject(OkxOrderHandler)

  listen(ws: WebsocketClientWrapper) {
    if (ws.isBybit) {
      return this.bybitHandler.listen(ws.bybit)
    }
    if (ws.isBinance) {
      return this.binanceHandler.listen(ws.binance)
    }
    if (ws.isOkx) {
      return this.okxHandler.listen(ws.okx)
    }
    throw new Error(`Unknown WebsocketClientWrapper`)
  }

}
